import React,{useEffect, useState} from "react";
import css from "./Themer.module.css";
import {crescent0,sun0} from "Assets";
import {useAppContext} from "Resources";


export default function Themer(){
    const [context,setContext]=useAppContext();
    return (
        <button 
            className={css.themer}
            onClick={()=>{
                setContext({theme:context.theme!=="light"?"light":"dark"});
            }}
        >
            <img 
                alt="theme image"
                src={hasLightTheme?crescent0(textColor):sun0(textColor)}
            />
        </button>
    )
}
